class Reservation {
    constructor() {
        this.reservationInfoRequestAjax = false;
    }

    initialize() {
        $('button[data-product-book]').off('click').on('click', function () {
            $.magnificPopup.open({
                items: {
                    src: '#book',
                },
                type: 'inline',
                midClick: true,
                removalDelay: 500,
                closeMarkup: `<button title="close" type="button" class="mfp-close"></button>`,
            });
        });
    }

    check() {
        if (
            !window.selectedSkuId
            || !(window.offersTree[window.selectedSkuId])
        ) {
            return;
        }

        let that = this;

        let selectedSku = window.offersTree[window.selectedSkuId];
        let buttonReservation = $('[data-product-book]');
        let scrollReservation = $('[data-scroll-section-book]');
        let popupReservation = $('#book[data-popup-modal]');
        let popupReservationOk = $('#book-ok[data-popup-modal]');
        let popupReservationShops = popupReservation.find('[data-product-select-shop]');
        let productReservationShops = $('[data-section-book-wrap]');
        let productReservationShopsList = productReservationShops.find('[data-section-book-list]');
        let courierBlock = $('.deliverymethod-tab[data-deliverymethod="courier"]');
        let pickubBlock = $('.deliverymethod-tab[data-deliverymethod="pickup"]');
        let pickubBlockList = $('.deliverymethod-section[data-deliverymethod="pickup"] .product__pickup');

        if (that.reservationInfoRequestAjax) {
            that.reservationInfoRequestAjax.abort();
        }

        scrollReservation.parent().addClass('d-none');
        buttonReservation.removeClass('d-none').addClass('btn--loading').prop('disabled', true);
        productReservationShops.addClass('d-none');

        that.reservationInfoRequestAjax = $.ajax({
            url: '/local/ajax/reservation_info.php',
            method: 'POST',
            dataType: 'json',
            data: {
                id: selectedSku.ID,
                artnumber: selectedSku.ARTNUMBER,
            }
        }).done(function (response) {
            if (
                (response.status === 'ok')
                && response.shops.length
            ) {
                scrollReservation.parent().removeClass('d-none');
                buttonReservation.removeClass('btn--loading').prop('disabled', false);

                popupReservation.find('input[name="sku_id"]').val(selectedSku.ID);

                popupReservation.find('[data-product-title]').text(selectedSku.PRODUCT_NAME);
                popupReservationOk.find('[data-product-title]').text(selectedSku.PRODUCT_NAME);

                popupReservation.find('[data-product-option-color]').toggleClass('d-none', (selectedSku.COLOR === ''));
                popupReservationOk.find('[data-product-option-color]').toggleClass('d-none', (selectedSku.COLOR === ''));
                popupReservation.find('[data-product-option-color-value]').text(selectedSku.COLOR);
                popupReservationOk.find('[data-product-option-color-value]').text(selectedSku.COLOR);

                popupReservation.find('[data-product-option-size]').toggleClass('d-none', (selectedSku.SIZE === ''));
                popupReservationOk.find('[data-product-option-size]').toggleClass('d-none', (selectedSku.SIZE === ''));
                popupReservation.find('[data-product-option-size-value]').text(selectedSku.SIZE);
                popupReservationOk.find('[data-product-option-size-value]').text(selectedSku.SIZE);

                popupReservation.find('[data-product-option-length]').toggleClass('d-none', (selectedSku.LENGTH === ''));
                popupReservationOk.find('[data-product-option-length]').toggleClass('d-none', (selectedSku.LENGTH === ''));
                popupReservation.find('[data-product-option-length-value]').text(selectedSku.LENGTH);
                popupReservationOk.find('[data-product-option-length-value]').text(selectedSku.LENGTH);

                popupReservationShops.html('');
                productReservationShops.removeClass('d-none');
                productReservationShopsList.html('');

                if (courierBlock.length) {
                    courierBlock.trigger('click');
                }
                
                if (pickubBlock.length) {
                    pickubBlock.addClass('d-none');
                }

                if (pickubBlockList.length) {
                    pickubBlockList.html('');
                }

                $.each(response.shops, function (index, shop) {
                    let shopAddressPopup = '';
                    let shopAddressList = '';
                    let shopTitle = '';
                    let shopAvailability = '';

                    let addresses = (shop.DESCRIPTION ? shop.DESCRIPTION.split("\n") : '');

                    if (addresses[0]) {
                        shopAddressPopup = addresses[0].trim();
                    }
                    if (!shopAddressPopup) {
                        shopAddressPopup = shop.ADDRESS;
                    }

                    if (addresses[1]) {
                        shopAddressList = addresses[1].trim();
                    }

                    if (!shopAddressList) {
                        shopAddressList = shop.ADDRESS;
                    }

                    if (shop.TITLE) {
                        shopTitle = shop.TITLE;
                    }

                    if (shop.QUANTITY) {
                        shopAvailability = shop.QUANTITY;
                    }

                    popupReservationShops.append(`
                        <option value="${shop.XML_ID}">
                            ${shopAddressPopup}
                        </option>
                    `);

                    productReservationShopsList.append(`
                        <tr class="table-address__tr">
                            <td class="table-address__td color-black" data-td="Адрес">
                                ${shopAddressList}
                            </td>

                            <td class="table-address__td" data-td="Время работы">
                                ${shop.SCHEDULE}
                            </td>

                            <td class="table-address__td text-right" data-td>
                                <a class="btn btn--border-black-hover btn--sm" data-product-book="${shop.XML_ID}" data-popup href="#book">
                                    ЗАБРОНИРОВАТЬ
                                </a>
                            </td>
                        </tr>
                    `);

                    if (pickubBlock.length && pickubBlock.hasClass('d-none')) {
                        pickubBlock.removeClass('d-none');
                    }
    
                    if (pickubBlockList.length) {
                        pickubBlockList.append(`
                            <div class="product__pickup-shop">
                                <div class="product__pickup-shop_title">
                                    ${shopTitle}
                                </div>
                                <div class="product__pickup-shop_address">
                                    ${shopAddressList}
                                </div>
                                <div class="product__pickup-shop_availability">
                                    Доступное количество товара: <span>${shopAvailability}</span>
                                </div>
                                <div class="product__pickup-shop_workhours">
                                    Режим работы: ${shop.SCHEDULE}
                                </div>
                                <a href="javascript:void(0)" class="product__pickup-shop_buy js-product-pickup-buy">Перейти к оформлению</a>
                            </div>
                        `);
                    }
                });

                if (window.Popup) {
                    $.each(productReservationShopsList.find('[data-popup]'), function () {
                        let popup = new window.Popup($(this));
                        popup.initialize();
                    });
                }

                productReservationShopsList.find('[data-product-book]').click(function (e) {
                    let shopXmlId = $(this).data('product-book');

                    popupReservationShops.find('option').prop('selected', false);
                    popupReservationShops.find('option[value="' + shopXmlId + '"]').prop('selected', true);
                });

                scrollReservation.on('click', function() {
                    pickubBlock.trigger('click');
                });

            } else {
                buttonReservation.removeClass('btn--loading').addClass('d-none');

                if (courierBlock.length) {
                    courierBlock.trigger('click');
                }
                
                if (pickubBlock.length) {
                    pickubBlock.addClass('d-none');
                }

                if (pickubBlockList.length) {
                    pickubBlockList.html('');
                }
            }
        });
    }
}

$(window).on('load', () => {
    window.Reservation = new Reservation();
    window.Reservation.initialize();
});